export default __webpack_public_path__ + "static/media/rating-2.c4db8389.svg";